var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.873,
    height: 5.409,
    viewBox: "0 0 10.873 5.409",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arrow_fill",
    "data-name": "Arrow fill",
    transform: "translate(-210.418 -948.322)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "arrow_drop_down_FILL1_wght400_GRAD0_opsz48",
    d: "M5.437,5.409,0,0H10.873Z",
    transform: "translate(221.291 953.731) rotate(180)",
    fill: "#9eabb0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowFill);
export default __webpack_public_path__ + "static/media/arrow_fill.697c5e4d1f4812d3caf4336254d8a81b.svg";
export { ForwardRef as ReactComponent };